import React from "react";

function Home() {
  return (
    <section
      className="text-light text-center d-flex align-items-center"
      style={{
        minHeight: "100vh",
        background:
          "linear-gradient(to right, #0f2027, #203a43, #2c5364)", // dark gradient
      }}
    >
      <div className="container">
        <h1 className="display-3 fw-bold mb-3">
          Welcome to <span className="text-warning">MRDEVWORKS</span>
        </h1>
        <p className="lead mb-4">
          We craft stunning custom, wordpress and e-commerce website solutions, along with SEO, logo design and ads services.
        </p>
        <a href="#services" className="btn btn-warning btn-lg px-4 shadow">
          Explore Services
        </a>
      </div>
    </section>
  );
}

export default Home;
